module.exports = __webpack_public_path__ + "media/img/close-04106c3b9b6a49c3e10e9c563b6628f0.svg";